import "./Preloader.scss";

import React, { Component, useEffect } from "react";
import { inject, observer, useLocalObservable } from "mobx-react";
import { observable, toJS } from "mobx";
import Spinner from "react-spinkit";

// import config from "../../config/config.js";

interface Props {
  //progressValue: number;
  progressText: string;
  loading: boolean;
  timeout?: number;
}
const Preloader: React.FC<Props> = ({ progressText, loading, timeout = 10000 }) => {
  const state = useLocalObservable(() => ({
    progressValue: undefined as number | undefined,
    progressText,
    loading,
    style: {},
  }));

  const show = () => {
    state.style = {};
  };

  const hide = () => {
    console.log("Loader hided by timeout");
    // this.store.consoleLog("Loader hided by timeout");
    state.style = { display: "none" };
  };

  // useEffect(() => {
  //   console.log("useEffect 1");
  //   show();
  //   if (timeout) {
  //     const timer = setTimeout(() => {
  //       hide();
  //     }, timeout);
  //     return () => clearTimeout(timer); // Cleanup timer on unmount
  //   }
  // }, [timeout]);

  // useEffect(() => {
  //   console.log("useEffect 2");
  //   show();

  //   if (!timeout) {
  //     const timer = setTimeout(() => {
  //       hide();
  //     }, timeout);
  //     return () => clearTimeout(timer);
  //   }
  //   state.progressText = progressText;
  // }, [progressText, timeout]);

  if (!loading) {
    return null;
  }
  const style = toJS(state.style);
  return (
    <div className="preloaderOverlay" style={style}>
      <div className="spinner">
        <Spinner
          name="line-spin-fade-loader"
          style={
            state.progressValue
              ? { marginLeft: "68px", top: "-177px", left: "240px" }
              : { transform: "translateX(50%)" }
          }
          color="white"
          fadeIn={"none"}
        />
        <div
          // style={
          //   this.progressValue
          //     ? {
          //         width: "500px",
          //         textAlign: "center",
          //         backgroundColor: "#ffffffc9",
          //         padding: "30px",
          //         borderRadius: "15px",
          //       }
          //     : { display: "none" }
          // }
          style={{
            paddingTop: "40px",
          }}
        >
          {state.progressValue && (
            <h4 style={{ color: "#4b4646", marginTop: "10px", fontSize: "30px" }}>{state.progressValue}%</h4>
          )}
          {progressText && <h4 style={{ color: "white", marginTop: "25px", fontSize: "15px" }}>{progressText}</h4>}
          {/* {this.props.onTerminate && (
            <div style={{ width: '155px', margin: 'auto', marginTop: '36px' }} className='terminateButton' onClick={() => this.props.onTerminate()}>
              {t('lblTerminateRequest').toUpperCase()}
            </div>
          )} */}
        </div>
      </div>
    </div>
  );
};

export default Preloader;
